appSocial.directive('contextMenu', ['ContextMenuService',
    /**
     * @param {ContextMenuService} ContextMenuService
     */
    function (ContextMenuService) {
        return {
            restrict: 'EA',
            scope: {
                contextMenuConfig: '<'
            },
            compile: function () {
                return {
                    post: function postLink(scope, el, attrs) {
                        const instanceId = Math.random() * 999999;

                        const portal = $(el);
                        const wrapper = portal.find('.dropdown-menu');
                        if (!wrapper) {
                            throw new Error("Add '.dropdown-menu' class to <ul> element!");
                        }
                        portal.attr('data-instance-id', instanceId);

                        /**
                         * @type Menu
                         */
                        const instance = {
                            id: instanceId,
                            portal,
                            wrapper,
                            isOpen: false,
                            config: scope.contextMenuConfig || {}
                        }

                        ContextMenuService.register(instance);

                        el.on('click', function (event) {
                            event.preventDefault();
                            ContextMenuService.show(instance);
                        })

                        el.on('$destroy', function () {
                            ContextMenuService.remove(instance);
                        })
                    }
                }
            },
            link: function (scope, el) {

            }
        }
    }
])
